import { Component, OnInit, Input } from '@angular/core';
import { ArrowComponent } from './arrow.component';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-arrow',
	templateUrl: './arrow.indra.component.html',
	styleUrls: ['./arrow.component.scss']
})
export class TAPArrowComponent extends ArrowComponent implements OnInit {
	@Input()
	legs;

	@Input()
	stops = [];

	@Input()
	commercialStops = [];

	@Input()
	allStops = [];


	constructor(
		private ibeAdminService: INDRAIbeAdminService,
	) {
		super();
	}

	ngOnInit() {
	}

	/**
	 * Return flight arrow classes
	 */
	INDRA_printArrowStyles() {
		return {
			// 'has-stopover': this.legs === 'layover',
			'has-stopover': true,
			'show-small-dots': this.stops.length > 2
		};
	}

	/**
	 * Check if flight has stops
	 */
	INDRA_hasStops() {
		return this.stops;

	}

	INDRA_hasCommercialStops() {
		return this.commercialStops;
	}

	INDRA_hasAllStops() {
		return this.allStops;
	}
	
	getLocation(stop) {

		if((stop.stopTime > 0 && !stop.stopover) && (stop.technicalStops != null)){

			let totalMin = stop.stopTime;
			let hours = Math.floor(totalMin / 60);
			let min = totalMin % 60;

			return stop.arrivalAirport + " " + this.ibeAdminService.getTranslationValue('bookingDetails.alt.stopfor') + " " + hours + "h" + min + "min | " + this.ibeAdminService.getTranslationValue('bookingDetails.text.commercialStopIn') + " " + stop.technicalStops[0].location;
			
		} else if(stop.stopTime > 0 && !stop.stopover){

			let totalMin = stop.stopTime;
			let hours = Math.floor(totalMin / 60);
			let min = totalMin % 60;

			// Note: Workaround for now to handle to scenario/basis for determining stop tooltip (TODO update)
			if (stop.airport && stop.airport.location) {
				return stop.airport.location.city;
			} else if (stop.arrivalAirport) {
				return stop.arrivalAirport + " " + this.ibeAdminService.getTranslationValue('bookingDetails.alt.stopfor') + " " + hours + "h" + min + "min";
			} 
		} else if (stop.technicalStops.length > 0) {

			let totalMin = stop.technicalStops[0].duration;
			let hours = Math.floor(totalMin / 60);
			let min = totalMin % 60;
			return stop.technicalStops[0].location + " " + this.ibeAdminService.getTranslationValue('bookingDetails.alt.stopfor') + " " + hours + "h" + min + "min";
		}
		
		
		return '';
	}
}
